import icons from '@bonanza-social/moonlight/lib/assets/icons';
import { PromoTargetSchema } from '@bonanza-social/promos';
import { z } from '@bonanza-social/toolkit/api';
import { BoxesArrayType } from './InviteFriendsRewards.types';

export const rewardBadgeMap: Partial<
  Record<z.infer<typeof PromoTargetSchema>, keyof typeof icons>
> = {
  FreeSpins: 'freeSpins',
  Coins: 'bonanzaCoin',
  InstantWheel: 'rewardWheel',
  Cash: 'bonanzaDollar',
  Bonus: 'bonanzaCoin',
  Wheel: 'metaWheel',
  Scratcher: 'scratchcards',
};

export const rewardNamesMap: Partial<
  Record<z.infer<typeof PromoTargetSchema>, keyof RegisteredLocales['common']>
> = {
  FreeSpins: 'freeSpins',
  Coins: 'coins',
  Cash: 'cash',
  Bonus: 'bonus',
  InstantWheel: 'instantWheel',
};

export const boxesArray: BoxesArrayType[] = [
  { type: 'referrer', locKey: 'unique_link_you_get' },
  { type: 'referee', locKey: 'unique_link_they_get' },
];
